import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  AfterViewInit,
} from '@angular/core';

import { SnCamera } from '@lib/api/entities';
import { SnCamerasAPI } from '@lib/api/services';

@Component({
  selector: 'sn-camera-share',
  templateUrl: './camera-share.component.html',
  styleUrls: ['./camera-share.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnCameraShareComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() public cameraId: any;
  @Input() public message: any;

  public viewCamera: boolean = false;
  public camera: SnCamera;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _camerasAPI: SnCamerasAPI,
    private readonly _cd: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this._camerasAPI
      .getCamera(this.cameraId)
      .pipe(takeUntil(this._destroy$))
      .subscribe((camera) => {
        this.camera = camera;
        this._cd.detectChanges();
      });
  }

  public ngAfterViewInit(): void {
    this._cd.detectChanges();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
